import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RegisterComponent } from './component/register/register.component';
import { RouterModule, Routes } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { LoginComponent } from './login/login.component';
import { AuthService } from '../../appServices/AuthService/auth.service';
import { LoginService } from '../../appServices/LoginService/login.service';
import { authInterceptorProviders } from '../../appCommon/Interceptor/auth.interceptor';
import { ToastModule } from 'primeng/toast';
import {AuthGuard} from '../../appCommon/AuthGuard/auth.guard'
import { Modules } from 'src/app/appCommon/Enums/enum';
import { ErrorPageComponent } from '../pages/static-pages/components/error-page/error-page.component';
import { LoginErrorComponent } from '../pages/static-pages/components/login-error/login-error.component';
import { LogOutComponent } from '../pages/static-pages/components/log-out/log-out.component';

const routes: Routes = [
  { path: '', redirectTo: Modules.Login },
  { path: Modules.Login, component: LoginComponent },
  { path: Modules.Register, component: RegisterComponent },
   { path: Modules.ErrorPage, component: ErrorPageComponent },
   { path: Modules.LoginError, component: LoginErrorComponent },
   { path: Modules.LogOut, component: LogOutComponent }

];

@NgModule({
  declarations: [RegisterComponent, LoginComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    ButtonModule,
    FormsModule,
    HttpClientModule,
    ToastModule
  ],
  providers: [AuthService, LoginService, authInterceptorProviders],
})
export class LoginRegisterModule {}
